export default "__VITE_ASSET__C05b1zHw__"